import { Backdrop, Box, keyframes, styled } from '@mui/material';
import { useAppSelector } from '../../../redux/hooks';
import logo from '../../../assets/images/logo.png';

interface DotProps {
  delay: string;
}

interface LoadingProps {
  open?: boolean;
  message?: string;
}

const bounceDelay = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.7;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Dot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'delay',
})<DotProps>(({ delay }) => ({
  width: 16,
  height: 16,
  margin: '0 6px',
  borderRadius: '50%',
  backgroundColor: '#fff',
  display: 'inline-block',
  animation: `${bounceDelay} 1.4s infinite ease-in-out both`,
  animationDelay: delay,
}));

const Loading: React.FC<LoadingProps> = ({ open = false, message: externalMessage }) => {
  const {
    isScreenLoading,
    message: stateMessage,
    isReceiveOperationLoading,
    receiveOperationMessage,
  } = useAppSelector((state) => state.loading);

  const isOpen = open || isScreenLoading || isReceiveOperationLoading;
  const effectiveMessage = open
    ? (externalMessage ?? receiveOperationMessage ?? stateMessage)
    : (receiveOperationMessage ?? stateMessage);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 999,
        backgroundColor: 'rgba(0,0,0,0.75)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
      open={isOpen}
    >
      <Box
        component="img"
        src={logo}
        alt={'Crosland'}
        sx={{
          width: 80,
          height: 'auto',
          mb: 3,
          userSelect: 'none',
        }}
        draggable={false}
      />
      <Box sx={{ display: 'flex' }}>
        <Dot delay="0s" />
        <Dot delay="0.16s" />
        <Dot delay="0.32s" />
      </Box>
      {effectiveMessage && (
        <Box
          sx={{
            mt: 3,
            maxWidth: 420,
            textAlign: 'center',
            fontSize: '0.95rem',
            lineHeight: 1.5,
          }}
        >
          {effectiveMessage}
        </Box>
      )}
    </Backdrop>
  );
};

export default Loading;
